module.exports = __webpack_public_path__ + "static/img/keep_benefit_shop.1f2ac31e.png";